import { useState, useEffect, useContext } from "react";
import { sendApiRequest } from "../../services/Base/base-service";
import { useNavigate } from "react-router-dom";
import { useSignIn, useSignOut } from "react-auth-kit";
import UserContext from "../../store/user-context";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Alert,
  Spinner,
} from "design-react-kit";
import { showStatus } from "../../services/helpers";
import StagedFlowStatusEnum from "../../helpers/Enums/StagedFlowStatusEnum";

const AuthModuleErrorsModal = ({
  modalOpen,
  modalCloseHandler,
  selectedFlow,
  isArchivePage,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [stagedFlowErrors, setStagedFlowErrors] = useState(null);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const signIn = useSignIn();
  const signOut = useSignOut();

  const userContext = useContext(UserContext);

  useEffect(() => {
    if (modalOpen && selectedFlow !== null && selectedFlow !== undefined) {
      if (!isArchivePage) {
        getErrors();
      } else {
        getHistoryErrors();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalOpen, selectedFlow]);

  const getErrors = () => {
    setError(null);
    setIsLoading(true);
    setStagedFlowErrors(null);
    sendApiRequest(
      `StagedFlow/GetStagedFlowErrorInfo?Status=${
        selectedFlow.stagedFlowStatusId ===
        StagedFlowStatusEnum.NotValidForPriceCalculation
          ? StagedFlowStatusEnum.PriceNotCalculated
          : selectedFlow.stagedFlowStatusId
      }&StagedFlowId=${selectedFlow.id}`,
      "GET",
      true,
      null,
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined && response.errors !== null) {
        setError(response.errors);
      } else {
        setStagedFlowErrors(response.data);
      }
      setIsLoading(false);
    });
  };

  const getHistoryErrors = () => {
    setError(null);
    setStagedFlowErrors(null);
    setIsLoading(true);
    sendApiRequest(
      `StagedFlow/GetStagedFlowHistoryErrorInfo?stagedFlowHistoryId=${selectedFlow.historyId}`,
      "GET",
      true,
      null,
      signIn,
      signOut,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response !== undefined && response.errors !== null) {
        setError(response.errors);
      } else {
        setStagedFlowErrors(response.data);
      }
      setIsLoading(false);
    });
  };

  return (
    <Modal
      id="stagedFlowErrorsModal"
      isOpen={modalOpen}
      toggle={modalCloseHandler}
      align="center"
      scrollable
      labelledBy="stagedFlowErrors"
    >
      <ModalHeader toggle={modalCloseHandler} id="stagedFlowErrors">
        <h5 className="text-center">Errori flusso</h5>
      </ModalHeader>
      <ModalBody id="stagedFlowErrorsBody">
        <div>
          {error !== null && error.length !== undefined && (
            <Alert color="danger" className="mx-auto">
              {error.map((item) => (
                <p key={item}>{item}</p>
              ))}
            </Alert>
          )}
          {isLoading && (
            <p style={{ height: "50px" }}>
              <Spinner double active />
            </p>
          )}

          <div className="mb-2">
            <p>Nome del flusso:</p>
            <p>
              {stagedFlowErrors !== null && stagedFlowErrors !== undefined && (
                <span style={{ color: "#0073e6 " }}>
                  {stagedFlowErrors.stageFlowName}
                </span>
              )}
            </p>
          </div>
          {modalOpen && (
            <div className="mb-3 d-flex">
              <p className="mr-3">Stato:</p>
              <p>{showStatus(selectedFlow)}</p>
            </div>
          )}
          {stagedFlowErrors !== null &&
            stagedFlowErrors !== undefined &&
            stagedFlowErrors.errors !== null &&
            stagedFlowErrors.errors !== undefined &&
            stagedFlowErrors.errors.length > 0 && (
              <div>
                <h6>Errori generali:</h6>
                <ul>
                  {stagedFlowErrors.errors.map((err, i) => (
                    <li key={i}>{err}</li>
                  ))}
                </ul>
              </div>
            )}
          {stagedFlowErrors !== null &&
            stagedFlowErrors !== undefined &&
            stagedFlowErrors.notificationErrorInfos !== null &&
            stagedFlowErrors.notificationErrorInfos !== undefined &&
            stagedFlowErrors.notificationErrorInfos.length > 0 && (
              <div>
                <h6>Errori di notifica:</h6>
                <ul>
                  {stagedFlowErrors.notificationErrorInfos.map((err) => (
                    <li key={err.index}>
                      <p>Index: {err.index}</p>
                      <p>Oggetto: {err.subject}</p>
                      <p>Protocollo: {err.protocolNumber}</p>
                      <p>Pagamento: numero avviso: {err.paymentNoticeCode}</p>
                      <p>
                        Destinatario: codice fiscale: {err.recipientFiscalCode}
                      </p>
                      <p>
                        Errori:
                        <ul>
                          {err.errors.map((error, i) => (
                            <li key={i}>{error}</li>
                          ))}
                        </ul>
                      </p>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          {stagedFlowErrors !== null &&
            stagedFlowErrors !== undefined &&
            stagedFlowErrors.notificationErrorInfosJsonV2 !== null &&
            stagedFlowErrors.notificationErrorInfosJsonV2 !== undefined &&
            stagedFlowErrors.notificationErrorInfosJsonV2.length > 0 && (
              <div>
                <h6>Errori di notifica:</h6>
                <ul>
                  {stagedFlowErrors.notificationErrorInfosJsonV2.map(
                    (notificationErrorInfoJsonV2) => (
                      <li key={notificationErrorInfoJsonV2.index}>
                        <p>Index: {notificationErrorInfoJsonV2.index}</p>
                        <p>Oggetto: {notificationErrorInfoJsonV2.subject}</p>
                        <p>
                          Protocollo:
                          {notificationErrorInfoJsonV2.protocolNumber}
                        </p>
                        <p>
                          Errori:
                          <ul>
                            {notificationErrorInfoJsonV2.errors.map(
                              (error, i) => (
                                <li key={i}>{error}</li>
                              )
                            )}
                          </ul>
                        </p>
                        {notificationErrorInfoJsonV2.recipientErrorInfos !==
                          null &&
                          notificationErrorInfoJsonV2.recipientErrorInfos !==
                            undefined &&
                          notificationErrorInfoJsonV2.recipientErrorInfos
                            .length > 0 && (
                            <div>
                              <h6>Errori di destinatario:</h6>
                              <ul>
                                {notificationErrorInfoJsonV2.recipientErrorInfos.map(
                                  (recipientErrorInfo) => (
                                    <li key={recipientErrorInfo.index}>
                                      <p>Index: {recipientErrorInfo.index}</p>
                                      <p>
                                        Codice fiscale:{" "}
                                        {recipientErrorInfo.recipientFiscalCode}
                                      </p>
                                      <p>
                                        Errori:
                                        <ul>
                                          {recipientErrorInfo.errors.map(
                                            (error, i) => (
                                              <li key={i}>{error}</li>
                                            )
                                          )}
                                        </ul>
                                      </p>
                                      {recipientErrorInfo.paymentErrorInfos !==
                                        null &&
                                        recipientErrorInfo.paymentErrorInfos !==
                                          undefined &&
                                        recipientErrorInfo.paymentErrorInfos
                                          .length > 0 && (
                                          <div>
                                            <h6>
                                              Errori di pagamenti di
                                              destinatario:
                                            </h6>
                                            <ul>
                                              {recipientErrorInfo.paymentErrorInfos.map(
                                                (paymentErrorInfo) => (
                                                  <li
                                                    key={paymentErrorInfo.index}
                                                  >
                                                    <p>
                                                      Index:{" "}
                                                      {paymentErrorInfo.index}
                                                    </p>
                                                    {paymentErrorInfo.paymentPagoPaErrorInfo !==
                                                      null &&
                                                      paymentErrorInfo.paymentPagoPaErrorInfo !==
                                                        undefined && (
                                                        <div>
                                                          <h6>
                                                            Errori di pagamento
                                                            pagoPA:
                                                          </h6>
                                                          <ul>
                                                            <li>
                                                              <p>
                                                                Nome file:
                                                                {
                                                                  paymentErrorInfo
                                                                    .paymentPagoPaErrorInfo
                                                                    .fileName
                                                                }
                                                              </p>
                                                              <p>
                                                                Codice fiscale:
                                                                {
                                                                  paymentErrorInfo
                                                                    .paymentPagoPaErrorInfo
                                                                    .recipientFiscalCode
                                                                }
                                                              </p>
                                                              <p>
                                                                Codice avviso:
                                                                {
                                                                  paymentErrorInfo
                                                                    .paymentPagoPaErrorInfo
                                                                    .paymentNoticeCode
                                                                }
                                                              </p>
                                                              <p>
                                                                Errori:
                                                                <ul>
                                                                  {paymentErrorInfo.paymentPagoPaErrorInfo.errors.map(
                                                                    (
                                                                      error,
                                                                      i
                                                                    ) => (
                                                                      <li
                                                                        key={i}
                                                                      >
                                                                        {error}
                                                                      </li>
                                                                    )
                                                                  )}
                                                                </ul>
                                                              </p>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      )}
                                                    {paymentErrorInfo.paymentF24ErrorInfo !==
                                                      null &&
                                                      paymentErrorInfo.paymentF24ErrorInfo !==
                                                        undefined && (
                                                        <div>
                                                          <h6>
                                                            Errori di pagamento
                                                            F24:
                                                          </h6>
                                                          <ul>
                                                            <li>
                                                              <p>
                                                                Nome file:
                                                                {
                                                                  paymentErrorInfo
                                                                    .paymentF24ErrorInfo
                                                                    .fileName
                                                                }
                                                              </p>
                                                              <p>
                                                                Titolo
                                                                documento:
                                                                {
                                                                  paymentErrorInfo
                                                                    .paymentF24ErrorInfo
                                                                    .documentTitle
                                                                }
                                                              </p>
                                                              <p>
                                                                Errori:
                                                                <ul>
                                                                  {paymentErrorInfo.paymentF24ErrorInfo.errors.map(
                                                                    (
                                                                      error,
                                                                      i
                                                                    ) => (
                                                                      <li
                                                                        key={i}
                                                                      >
                                                                        {error}
                                                                      </li>
                                                                    )
                                                                  )}
                                                                </ul>
                                                              </p>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      )}
                                                  </li>
                                                )
                                              )}
                                            </ul>
                                          </div>
                                        )}
                                    </li>
                                  )
                                )}
                              </ul>
                            </div>
                          )}
                        {notificationErrorInfoJsonV2.attachmentErrorInfos !==
                          null &&
                          notificationErrorInfoJsonV2.attachmentErrorInfos !==
                            undefined &&
                          notificationErrorInfoJsonV2.attachmentErrorInfos
                            .length > 0 && (
                            <div>
                              <h6>Errori di allegato:</h6>
                              <ul>
                                {notificationErrorInfoJsonV2.attachmentErrorInfos.map(
                                  (attachmentErrorInfo) => (
                                    <li key={attachmentErrorInfo.index}>
                                      <p>Index: {attachmentErrorInfo.index}</p>
                                      <p>
                                        Titolo documento:{" "}
                                        {attachmentErrorInfo.documentTitle}
                                      </p>
                                      <p>
                                        Nome file:{" "}
                                        {attachmentErrorInfo.fileName}
                                      </p>
                                      <p>
                                        Errori:
                                        <ul>
                                          {attachmentErrorInfo.errors.map(
                                            (error, i) => (
                                              <li key={i}>{error}</li>
                                            )
                                          )}
                                        </ul>
                                      </p>
                                    </li>
                                  )
                                )}
                              </ul>
                            </div>
                          )}
                      </li>
                    )
                  )}
                </ul>
              </div>
            )}
        </div>
        {stagedFlowErrors !== null &&
          stagedFlowErrors !== undefined &&
          stagedFlowErrors.notificationErrorInfos !== null &&
          stagedFlowErrors.notificationErrorInfos !== undefined &&
          stagedFlowErrors.notificationErrorInfos.length === 0 &&
          stagedFlowErrors.notificationErrorInfosJsonV2 !== null &&
          stagedFlowErrors.notificationErrorInfosJsonV2 !== undefined &&
          stagedFlowErrors.notificationErrorInfosJsonV2.length === 0 &&
          stagedFlowErrors.errors !== null &&
          stagedFlowErrors.errors !== undefined &&
          stagedFlowErrors.errors.length === 0 &&
          error === null && (
            <Alert color="info" className="mx-auto mt-2">
              <p>Nessun risultato trovato!</p>
            </Alert>
          )}
      </ModalBody>
    </Modal>
  );
};

export default AuthModuleErrorsModal;
